import { COLOR_WARNING } from 'styles/theme';
import { Tooltip } from '@material-ui/core';
import { formatDateForInput } from 'utilities/common';
import { isTaskOverdue } from 'modules/dashboard/taskStatus';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
  dueDate: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  overdueIcon: {
    color: COLOR_WARNING.main,
  },
}));

// A task's due date, with a warning icon once the task is overdue
const TaskDueDate = ({ task }) => {
  const classes = useStyles();

  return (
    <span className={classes.dueDate}>
      {formatDateForInput(task.dueDate)}
      {isTaskOverdue(task) && (
        <Tooltip title="Task is overdue">
          <WarningIcon fontSize="small" className={classes.overdueIcon} />
        </Tooltip>
      )}
    </span>
  );
};

TaskDueDate.propTypes = {
  task: PropTypes.shape({
    dueDate: PropTypes.string,
    taskStatusId: PropTypes.string,
  }).isRequired,
};

export default TaskDueDate;
